import type { Locale } from '@/features/basket/types/locale';
import type { DeviceType } from '@/types/types';

export enum Cookie {
  JUST_LOGGED_IN = 'just-logged-in',
  LOGIN_SECRET = 'login-secret',
  BASKET_ID = 'basket_id',
  CUSTOMER_EMAIL = 'customer-email',
  CUSTOMER_TYPE = 'customer-type',
  NEXT_LOCALE = 'NEXT_LOCALE',
  PAYMENT_ERROR_TIMEOUT = 'paymentStatusTimeout',
  DEVICE_TYPE = 'device-type',
  CUSTOMER_LOGIN_TYPE = 'customer-login-type',
  UPSELL_BASKET_ID = 'upsell_basket_id',
  AB_TESTS = 'ab_tests',
  IS_TOP_BAR_CLOSED = 'isTopBarClosed',
}

export type CustomerType = 'returner' | 'new';

export type CookieType = {
  [Cookie.JUST_LOGGED_IN]: boolean;
  [Cookie.LOGIN_SECRET]: string;
  [Cookie.BASKET_ID]: string;
  [Cookie.CUSTOMER_EMAIL]: string;
  [Cookie.CUSTOMER_TYPE]: CustomerType;
  [Cookie.NEXT_LOCALE]: Locale | string;
  [Cookie.PAYMENT_ERROR_TIMEOUT]: string;
  [Cookie.DEVICE_TYPE]: DeviceType;
  [Cookie.CUSTOMER_LOGIN_TYPE]: CustomerLoginType;
  [Cookie.UPSELL_BASKET_ID]: string;
  [Cookie.AB_TESTS]: string;
  [Cookie.IS_TOP_BAR_CLOSED]: boolean;
};

export enum CustomerLoginType {
  REGISTERED = 'registered',
  LOGGED_IN = 'loggedIn',
  GUEST = 'guest',
  SOCIAL = 'social',
}

export enum SessionStorage {
  ON_SUCCESSFULLY_LOGIN = 'onSuccessfullyLogin',
  AGCORE_WISHLIST_ITEMS = 'wishlistItems',
}

export type SessionStorageType = {
  [SessionStorage.ON_SUCCESSFULLY_LOGIN]: string;
};

export enum LocalStorage {
  CONSENTS = 'consents',
}

export interface LocalStorageType {
  [LocalStorage.CONSENTS]: Record<
    string,
    {
      't&c': boolean;
      review: boolean;
      email: boolean;
      sms: boolean;
      phone: boolean;
    }
  >;
}
